import Style from './PreventionCourseCard.style';
import { Headline, Paragraph, Image, Button } from 'Common';

export const PreventionCourseCard = ({ course, image, className, route }) => {
  return (
    <Style className={`${className}500`}>
      <Image src={image} alt={course.altTag} className="course-image" />

      <div className="course-content">
        <div className="course-text">
          <Paragraph className="course-tag extra-small-bold">{course.tag}</Paragraph>
          <Headline level={4} className="course-title" dangerouslySetInnerHTML={{ __html: course.title }} />
          <Paragraph className="course-description small">{course.description}</Paragraph>
        </div>

        <div className="button-wrapper">
          <Button className="course-button" variant="inverted" color={className} to={route}>
            {course.button}
          </Button>
        </div>
      </div>
    </Style>
  );
};
